module.exports = __webpack_public_path__ + "media/images/hitfun/welcome.bg-a2b0d4fb03d7b3e67946c86087066ea9.png";